import { registerMutation, registerQuery } from 'data-fetching-client';
import { productUpdatesReactiveVar } from '../productUpdatesReactiveVar';
import * as RolloutProductUpdatesAPI from './data/RolloutProductUpdatesAPI';
import { RolloutsAPI } from './data/RolloutsAPI';
import * as NewToYouAPI from './data/NewToYouAPI';
import { TranslationAPI } from './data/TranslationAPI';
import { FavoriteAPI } from './data/FavoriteAPI';
export const GET_ROLLOUT_PRODUCT_UPDATES = registerQuery({
  fieldName: 'rolloutProductUpdates',
  args: ['endReleaseDate', 'endStageDate', 'enrollmentStatus', 'featureGroup', 'impactLevels', 'isFavorite', 'limit', 'offset', 'product', 'query', 'recommended', 'rolloutState', 'rolloutType', 'sortReleaseDate', 'sortStageDate', 'startReleaseDate', 'startStageDate'],
  fetcher: ({
    endReleaseDate,
    endStageDate,
    enrollmentStatus,
    featureGroup,
    impactLevels,
    isFavorite,
    limit,
    offset,
    product,
    query,
    recommended,
    rolloutState,
    rolloutType,
    sortReleaseDate,
    sortStageDate,
    startReleaseDate,
    startStageDate
  }) => RolloutProductUpdatesAPI.fetchRolloutProductUpdates({
    endReleaseDate,
    endStageDate,
    enrollmentStatus,
    featureGroup,
    impactLevels,
    isFavorite,
    limit,
    offset,
    product,
    query,
    recommended,
    rolloutState,
    rolloutType,
    sortReleaseDate,
    sortStageDate,
    startReleaseDate,
    startStageDate
  })
});
export const GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID = registerQuery({
  fieldName: 'rolloutProductUpdate',
  args: ['id'],
  fetcher: RolloutProductUpdatesAPI.fetchRolloutProductUpdateByUpdateId
});
export const GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID = registerQuery({
  fieldName: 'rolloutProductUpdate',
  args: ['id'],
  fetcher: RolloutProductUpdatesAPI.fetchRolloutProductUpdateByRolloutId
});
export const GET_RECOMMENDED_ROLLOUT_PRODUCT_UPDATES = registerQuery({
  fieldName: 'rolloutProductUpdates',
  args: ['endReleaseDate', 'endStageDate', 'enrollmentStatus', 'featureGroup', 'impactLevels', 'isFavorite', 'limit', 'offset', 'product', 'query', 'recommended', 'rolloutState', 'rolloutType', 'sortReleaseDate', 'sortStageDate', 'startReleaseDate', 'startStageDate'],
  fetcher: ({
    endReleaseDate,
    endStageDate,
    enrollmentStatus,
    featureGroup,
    impactLevels,
    isFavorite,
    limit,
    offset,
    product,
    query,
    recommended,
    rolloutState,
    rolloutType,
    sortReleaseDate,
    sortStageDate,
    startReleaseDate,
    startStageDate
  }) => RolloutProductUpdatesAPI.fetchRecommendedRolloutProductUpdates({
    endReleaseDate,
    endStageDate,
    enrollmentStatus,
    featureGroup,
    impactLevels,
    isFavorite,
    limit,
    offset,
    product,
    query,
    recommended,
    rolloutState,
    rolloutType,
    sortReleaseDate,
    sortStageDate,
    startReleaseDate,
    startStageDate
  })
});
export const ENROLL_BETA = registerMutation({
  fieldName: 'enrollBeta',
  args: ['rolloutId', 'portalId', 'enrollId', 'enrollType', 'betaAccessType'],
  fetcher: request => RolloutsAPI.enrollBeta(request)
});
export const LEAVE_BETA = registerMutation({
  fieldName: 'leaveBeta',
  args: ['rolloutId', 'portalId', 'enrollId', 'enrollType', 'betaAccessType'],
  fetcher: request => RolloutsAPI.leaveBeta(request)
});
export const UPDATE_BETA_ENROLLMENT = registerMutation({
  fieldName: 'updateBetaEnrollment',
  args: ['requestToDisable', 'requestToEnable'],
  fetcher: RolloutsAPI.updateBetaEnrollment
});
export const updateProductUpdateCache = (cache, {
  productUpdateId,
  rolloutId,
  nextEnrollmentStatus,
  approvedAt
}) => {
  // update product updates cache
  const puCache = new Map(productUpdatesReactiveVar());
  const targetPU = puCache.get(productUpdateId);
  if (!targetPU) {
    return;
  }
  const targetGate = targetPU.rollout.gate;
  const shouldUpdateEnrollmentStatus = nextEnrollmentStatus === 'PENDING_APPROVAL' ? pu => pu.id.toString() === productUpdateId : pu => pu.rollout.gate === targetGate;
  for (const [puId, pu] of puCache.entries()) {
    if (shouldUpdateEnrollmentStatus(pu)) {
      const newPU = Object.assign({}, pu, {
        rollout: Object.assign({}, pu.rollout, {
          approvedAt,
          enrollmentStatus: nextEnrollmentStatus
        })
      });
      puCache.set(puId, newPU);
    }
  }
  productUpdatesReactiveVar(new Map(puCache));

  // update panel cache for both updateId and rolloutId
  const existingPanelQueryByUpdateId = cache.readQuery({
    query: GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID,
    variables: {
      id: productUpdateId
    }
  });
  const existingPanelUpdateByUpdateId = existingPanelQueryByUpdateId === null || existingPanelQueryByUpdateId === void 0 ? void 0 : existingPanelQueryByUpdateId.rolloutProductUpdate;
  if (existingPanelUpdateByUpdateId) {
    cache.writeQuery({
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID,
      variables: {
        id: productUpdateId
      },
      data: {
        rolloutProductUpdate: Object.assign({}, existingPanelUpdateByUpdateId, {
          rollout: Object.assign({}, existingPanelUpdateByUpdateId.rollout, {
            approvedAt,
            enrollmentStatus: nextEnrollmentStatus
          })
        })
      }
    });
  }
  const existingPanelQueryByRolloutId = cache.readQuery({
    query: GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID,
    variables: {
      id: rolloutId
    }
  });
  const existingPanelUpdateByRolloutId = existingPanelQueryByRolloutId === null || existingPanelQueryByRolloutId === void 0 ? void 0 : existingPanelQueryByRolloutId.rolloutProductUpdate;
  if (existingPanelUpdateByRolloutId) {
    cache.writeQuery({
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID,
      variables: {
        id: rolloutId
      },
      data: {
        rolloutProductUpdate: Object.assign({}, existingPanelUpdateByRolloutId, {
          rollout: Object.assign({}, existingPanelUpdateByRolloutId.rollout, {
            approvedAt,
            enrollmentStatus: nextEnrollmentStatus
          })
        })
      }
    });
  }
};
const featureGroupAdapter = featureGroups => featureGroups.filter(fg => !fg.isInternal).map(fg => fg.featureGroup).reduce((allFeatureGroups, featureGroup) => {
  allFeatureGroups.set(featureGroup.name, featureGroup);
  return allFeatureGroups;
}, new Map());
export const GET_FEATURE_GROUPS = registerQuery({
  fieldName: 'featureGroups',
  fetcher: () => TranslationAPI.getFeatureGroups().then(featureGroupAdapter)
});
const rolloutTypeAdapter = rolloutTypes => rolloutTypes.reduce((allRolloutTypes, {
  rolloutType,
  text
}) => {
  allRolloutTypes.set(rolloutType, text);
  return allRolloutTypes;
}, new Map());
export const GET_ROLLOUT_TYPES = registerQuery({
  fieldName: 'rolloutTypes',
  fetcher: () => TranslationAPI.getRolloutTypes().then(rolloutTypeAdapter)
});
export const ADD_FAVORITE = registerMutation({
  fieldName: 'addFavorite',
  args: ['rolloutId'],
  fetcher: FavoriteAPI.addFavorite
});
export const REMOVE_FAVORITE = registerMutation({
  fieldName: 'removeFavorite',
  args: ['rolloutId'],
  fetcher: FavoriteAPI.removeFavorite
});
export const GET_NEW_TO_YOU_TIMESTAMP = registerQuery({
  fieldName: 'newToYouTimestamp',
  args: [],
  fetcher: NewToYouAPI.getNewToYouTimestamp
});
export const UPDATE_NEW_TO_YOU_TIMESTAMP = registerMutation({
  fieldName: 'updateNewToYouTimestamp',
  args: [],
  fetcher: NewToYouAPI.updateNewToYouTimestamp
});